<template>
    <div class="datatable-dropdown" v-click-outside="hide">
        <Button :title="title" :badge="badge" :icon="icon" @click="showed = !showed" :disabled="disabled"/>
        <div class="datatable-dropdown-menu" v-if="showed">
            <slot>Empty</slot>
        </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import Button from "./ButtonComponent.vue";

export default {
    name: "DatatableDropdownComponent",
    props: {
        title: {
            type: String,
            default() {
                return '';
            }
        },
        icon: {
            type: String,
            default() {
                return 'icon-arrow-down22';
            }
        },
        badge: {
            type: String,
            default() {
                return null;
            }
        },
        disabled: {
            type: Boolean
        }
    },
    data() {
        return {
            showed: false
        }
    },
    methods: {
        hide() {
            this.showed = false;
        }
    },
    components: {
        Button
    },
    directives: {
        clickOutside: vClickOutside.directive
    }
}
</script>

<style scoped>
.datatable-dropdown {
    user-select: none;
    position: relative;
    display: inline-block;
}

.datatable-dropdown-menu {
    background: #ffffff;
    position: absolute;
    z-index: 10;
    margin-top: 10px;
    box-shadow: 0 4px 8px -2px #091e4240, 0 0 1px #091e424f;
    border-radius: 2px;
    min-width: 100%;
    white-space:nowrap;
}
</style>
